export { faroErrorBoundaryInitialState } from './const';

export { FaroErrorBoundary } from './FaroErrorBoundary';

export type {
  FaroErrorBoundaryFallbackRender,
  FaroErrorBoundaryProps,
  FaroErrorBoundaryState,
  ReactNodeRender,
  ReactProps,
} from './types';

export { withFaroErrorBoundary } from './withFaroErrorBoundary';
